import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { LocalizationProvider } from "@mui/lab";
import { Stack, TextField } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import axios from "axios";
import moment from "moment";
import Multiselect from "multiselect-react-dropdown";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import ReactPlayer from "react-player";
import { useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../App";
import cup from "../../../assets/images/page 1.png";
import LoaderPost from "../../Reuseable/LoaderPost";
import "./PostContentMaking.css";

const RoundInstructionVideoCreate = () => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const history = useHistory();
  const { slug } = useParams();
  const [event, setEvent] = useState({});

  const [loading, setLoading] = useState(true);
  const [events, setEvents] = useState([]);
  const [rounds, setRounds] = useState([]);
  const [auditionId, setAuditionId] = useState("");
  const [roundId, setRoundId] = useState("");
  const [file, setFile] = useState("");
  const [imageData, setImageData] = useState("");
  const [fileVideo, setFileVideo] = useState("");
  const [filePdf, setFilePdf] = useState("");
  const [videoFile, setVideoFile] = useState("");
  const [judges, setJudges] = useState([]);
  const [convertedContent, setConvertedContent] = useState(null);
  const [description, setDescription] = useState(null);
  const [errorList, setErrorList] = useState([]);

  const submitRoundInstruction = (e) => {
    e.preventDefault();
    const fData = new FormData();

    if (items.length > 0) {
      items.forEach((item) => {
        fData.append("judge_id[]", Number(item.id));
      });
    }
    fData.append("audition_id", auditionId);
    fData.append("round_info_id", roundId);
    fData.append("instruction", convertedContent);
    fData.append("description", description);
    fData.append("video", fileVideo);
    fData.append("image", imageData);
    fData.append("pdf", filePdf);
    fData.append("start_date", moment(startDate).format("YYYY-MM-DD"));
    fData.append("end_date", moment(endDate).format("YYYY-MM-DD"));

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(
          `/api/audition-admin/audition/round-instruction-video/store`,
          fData
        )
        .then((res) => {
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            fetchAuditions();
            // history.goBack();
          } else {
            setErrorList(res.data.validation_errors);
          }
        });
    });
  };

  const [startDate, setStartDate] = React.useState(new Date());
  const [endDate, setEndDate] = React.useState(new Date());

  const [items, setItems] = useState([]);

  const handleSelect = (selectedList) => {
    setItems(selectedList);
  };

  const handleRemove = (selectedList) => {
    setItems(selectedList);
  };

  const handleImageChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setImageData(file[0]);
  };
  const handleVideoChange = (file) => {
    setFileVideo(file[0]);
    setVideoFile(URL.createObjectURL(file[0]));
  };

  const handlePdfChange = (file) => {
    setFilePdf(file[0]);
  };

  const handleRoundChange = (event) => {
    setRoundId(event.target.value);
  };

  const handleChange = (event) => {
    setAuditionId(event.target.value);
    axios
      .get(`/api/audition-admin/audition_event/audition_single_by_id/${event.target.value}`)
      .then((res) => {
        if (res.data.status === 200) {
          let judges_array = [];
          res.data.event.assigned_judges.forEach((judge, index) => {
            let user = judge?.user;
            judges_array.push({
              name: user.first_name + " " + user.last_name,
              id: user.id,
            });
          });
          setJudges(judges_array);
        }
      });
  };

  const fetchAuditions = () => {
    axios.get(`/api/audition-admin/audition/events`).then((res) => {
      if (res.data.status === 200) {
        setEvents(res.data.events);
        // setLoading(false);
      }
    });
  };

  useEffect(() => {
    fetchAuditions();
  }, []);

  useEffect(() => {
    setLoading(true);
    var result = events.find((item) => item.id == auditionId);
    setEvent(result);

    setRounds(result?.audition_round);
    setLoading(false);
  }, [auditionId]);

  useEffect(() => {
    setLoading(true);
    var result = rounds.find((item) => item.id == roundId);

    setConvertedContent(result?.round_instruction?.instruction);

    if (result?.round_instruction?.video != null) {
      setVideoFile(videoCdnUrl + result?.round_instruction?.video);
    } else {
      setVideoFile("");
    }

    if (result?.round_instruction?.image != null) {
      setFile(imageCdnUrl + result?.round_instruction?.image);
    } else {
      setFile("");
    }

    setLoading(false);
  }, [roundId]);

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          <div className="">
            {/* <div className="d-flex px-4">
              <div className="faTrophy p-2">
                <img src={cup} alt="" className="mt-1" width="30px" />{" "}
                <span className="text-waning p-2 fw-bolder">
                  Get Round Instruction Video from Star
                </span>
              </div>
            </div> */}
            <div className="card card-bg head-line mb-2 mb-2">
              <div className="text-light d-flex justify-content-center p-2">
                <div className="faTrophy">
                  <img src={cup} alt="" width="30px" />
                </div>
                <h4 className="mx-3 text-warning fw-bold p-2">
                  Get Round Instruction Video from Star
                </h4>
              </div>
            </div>
            <div className="row card card-bg">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto row">
                <div className="my-2">
                  <form
                    onSubmit={submitRoundInstruction}
                    id="input_form"
                    encType="multipart/form-data"
                  >
                    <div className="row ms-5">
                      <div className="form-group row mt-3">
                        <label
                          for="staticEmail"
                          className="col-sm-3 fw-bold text-warning"
                        >
                          Select An Audition
                        </label>
                        <div className="col-sm-9">
                          <select
                            onChange={handleChange}
                            className="form-select reply-control text-black"
                            aria-label="Default select example"
                            id="audition_id"
                            name="audition_id"
                          >
                            <option value="0">--Select Audition--</option>
                            {events.map((event, index) => (
                              <option key={index} value={event?.id}>
                                {event?.title}
                              </option>
                            ))}
                          </select>
                          <span className="text-danger">
                            {errorList.audition_id}
                          </span>
                        </div>
                      </div>
                      <div className="form-group row mt-3">
                        <label
                          for="staticEmail"
                          className="col-sm-3 fw-bold text-warning "
                        >
                          Select A Round
                        </label>
                        <div className="col-sm-9">
                          <select
                            onChange={handleRoundChange}
                            className="form-select form-control reply-control"
                            aria-label="Default select example"
                            id="round_info_id"
                            name="round_info_id"
                          >
                            <option value="0">--Select Round--</option>
                            {rounds &&
                              rounds.length > 0 &&
                              rounds.map((round, index) => (
                                <option key={index} value={round?.id}>
                                  Round - {round?.round_num}
                                </option>
                              ))}
                          </select>
                          <span className="text-danger">
                            {errorList.round_info_id}
                          </span>
                        </div>
                      </div>
                      <div className="form-group row mt-3">
                        <label
                          for="staticEmail"
                          className="col-sm-3 fw-bold text-warning"
                        >
                          Select Superstar
                        </label>
                        <div className="col-sm-9">
                          <Multiselect
                            options={judges}
                            selectedValues={items}
                            onSelect={handleSelect}
                            onRemove={handleRemove}
                            className="reply-control tet-light"
                            displayValue="name"
                          />
                          <span className="text-danger">
                            {errorList.star_ids}
                          </span>
                        </div>
                      </div>

                      <div className="form-group row mt-3">
                        <label
                          for="description"
                          className="col-sm-3 fw-bold text-warning"
                        >
                          Description
                        </label>
                        <div className="col-sm-7">
                          <CKEditor
                            editor={ClassicEditor}
                            data={description}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setDescription(data);
                            }}
                            onBlur={(event, editor) => {}}
                            onFocus={(event, editor) => {}}
                          />
                          <span className="text-danger">
                            {errorList.description}
                          </span>
                        </div>
                      </div>

                      <div className="form-group row mt-3">
                        <label
                          for="instruction"
                          className="col-sm-3 fw-bold text-warning"
                        >
                          Instruction
                        </label>
                        <div className="col-sm-7">
                          <CKEditor
                            editor={ClassicEditor}
                            data={convertedContent}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setConvertedContent(data);
                            }}
                            onBlur={(event, editor) => {}}
                            onFocus={(event, editor) => {}}
                          />
                          <span className="text-danger">
                            {errorList.instruction}
                          </span>
                        </div>
                      </div>

                      <div className="form-group row mt-3">
                        <label
                          for="staticEmail"
                          className="col-sm-3 fw-bold text-warning"
                        >
                          Upload Video
                        </label>

                        <div className="col-sm-5 mb-2">
                          <div className="row my-4">
                            <div className="col-md-10">
                              {videoFile ? (
                                <>
                                  <ReactPlayer
                                    url={videoFile}
                                    // width="100%"
                                    controls={true}
                                    height="35vh"
                                  />
                                </>
                              ) : (
                                <></>
                              )}
                              <input
                                type="file"
                                name="file"
                                id="setFile"
                                className="inputfile w-25"
                                accept="video/mp4"
                                onChange={(e) =>
                                  handleVideoChange(e.target.files)
                                }
                              />

                              <label for="setFile">
                                <i className="fas fa-cloud-upload-alt"></i>{" "}
                                Upload Video
                              </label>
                              <span className="text-danger">
                                {errorList.video}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row mt-3">
                        <label
                          for="staticEmail"
                          className="col-sm-3 fw-bold text-warning"
                        >
                          Upload Image
                        </label>

                        <div className="col-sm-5 mb-2">
                          <div className="row my-4">
                            {file ? (
                              <img
                                src={file}
                                alt="..."
                                className="demo-preview-image img-fluid"
                              />
                            ) : (
                              ""
                            )}
                            <div className="col-md-10">
                              <input
                                type="file"
                                name="imageFile"
                                id="imageFile"
                                className="inputfile w-25"
                                accept="image/jpg,image/jpeg, image/png"
                                onChange={(e) =>
                                  handleImageChange(e.target.files)
                                }
                              />

                              <label for="imageFile">
                                <i className="fas fa-cloud-upload-alt"></i>{" "}
                                Upload Image
                              </label>
                              <span className="text-danger">
                                {errorList.image}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row mt-3">
                        <label
                          for="staticEmail"
                          className="col-sm-3 fw-bold text-warning "
                        >
                          Instruction pdf for the round
                        </label>

                        <div className="col-sm-7 mb-2">
                          <div className="row d-flex my-4">
                            <div className="col-md-2 text-white"></div>
                            <div className="col-md-5 inputeParent">
                              <input
                                type="file"
                                name="pdfFile"
                                id="pdfFile"
                                accept=".pdf"
                                className="inputfile w-25"
                                onChange={(e) =>
                                  handlePdfChange(e.target.files)
                                }
                              />
                              <label for="pdfFile">
                                <i className="fa-solid fa-file-pdf"></i> 1 MB
                                Maximum
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-group row mt-3">
                        <label
                          for="staticEmail"
                          className="col-sm-3 fw-bold text-warning "
                        >
                          Content Submission Date
                        </label>

                        <div className="col-md-3 dateParentPicker timeLengthPicker">
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Stack spacing={3}>
                              <DatePicker
                                disablePast
                                label="Start Date"
                                openTo="day"
                                views={["year", "month", "day"]}
                                value={startDate}
                                onChange={(newValue) => {
                                  setStartDate(newValue);
                                }}
                                renderInput={(params) => (
                                  <TextField {...params} />
                                )}
                              />
                            </Stack>
                          </LocalizationProvider>
                          <span className="text-danger">
                            {errorList.start_date}
                          </span>
                        </div>

                        <div className="col-md-3 dateParentPicker timeLengthPicker">
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Stack spacing={3}>
                              <DatePicker
                                disablePast
                                label="End Date"
                                openTo="day"
                                views={["year", "month", "day"]}
                                value={endDate}
                                onChange={(newValue) => {
                                  setEndDate(newValue);
                                }}
                                renderInput={(params) => (
                                  <TextField {...params} />
                                )}
                              />
                            </Stack>
                          </LocalizationProvider>
                          <span className="text-danger">
                            {errorList.end_date}
                          </span>
                        </div>

                        <div className="col-sm-7 row d-flex justify-content-end mb-2"></div>
                      </div>

                      <div className="row my-4">
                        <div className="col-md-3 mx-auto">
                          <button
                            className="btn btnConfirm w-100 px-4 fw-bold"
                            type="submit"
                          >
                            Confirm
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default RoundInstructionVideoCreate;
